import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "priceAmount", "recurringRule" ]

  connect() {
    this.togglePriceAmount()
    this.toggleRecurring()
  }

  togglePriceAmount() {
    const selected = this.element.querySelector("input[name='event[price_type]']:checked")
    const show = selected && selected.value === "paid"
    this.priceAmountTarget.classList.toggle("hidden", !show)
    if (!show) {
      const input = this.priceAmountTarget.querySelector("input")
      if (input) input.value = ""
    }
  }

  toggleRecurring() {
    const checkbox = this.element.querySelector("input[name='event[recurring]']")
    const show = checkbox && checkbox.checked
    this.recurringRuleTarget.classList.toggle("hidden", !show)
    if (!show) {
      const input = this.recurringRuleTarget.querySelector("input")
      if (input) input.value = ""
    }
  }
}
